import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonNewModule } from '../../common/button-new/button-new.module';
import { ButtonModule } from './../../common/button/button.module';
import { IconModule } from './../../common/icon/icon.module';
import { SpinnerModule } from './../../common/spinner/spinner.module';
import { MaskedInputComponent } from './masked-input.component';

@NgModule({
  declarations: [MaskedInputComponent],
  exports: [MaskedInputComponent],
  imports: [IconModule, CommonModule, ButtonModule, SpinnerModule, ButtonNewModule],
})
export class MaskedInputModule {}

export { MaskedInputComponent, TextMaskConfig } from './masked-input.component';
